import _ from 'lodash'
import {
    list,
    create,
    batchCreate,
    update,
    remove,
    batchRemove,
    groups,
    createGroup,
    updateGroup,
    removeGroup,
    batchGroup,
    batchShare,
    webPageInfo,
    mpa,
} from 'crm/services/material'
import {treeForEach} from 'utils'

function getInitParams() {
    return {
        type: 1,
        keyword: undefined, // 关键字搜索
        department_id: undefined,
        user_id: undefined,
        visible_type: undefined, // 可见范围
        only_mine: undefined, // 1 只看自己的
        category_id: undefined, // 分组
        limit: 10,
        offset: 0,
    }
}

function getInitState() {
    return {
        params: getInitParams(),
        list: [],
        selectedMaterialIds: [],
        total: 0,
        current: 0,
        groups: [],
        groupExpandedKeys: [],
        groupSelectedKey: null,
    }
}

export default {
    namespace: 'crm_material',

    state: getInitState(),

    effects: {
        *list({payload}, {call, put, select}) {
            const {params, groupSelectedKey} = yield select(({crm_material}) => crm_material)
            const query = {...params, ...payload.params}
            if (payload.page) {
                query.offset = params.limit * (payload.page - 1)
            }
            query.category_id = groupSelectedKey

            const res = yield call(list, query)
            if (res && res.data) {
                yield put({
                    type: 'setProperty',
                    payload: {
                        params: query,
                    },
                })
            }
            return {res, type: query.type}
        },
        *create({payload}, {call}) {
            return yield call(create, payload)
        },
        *batchCreate({payload}, {call}) {
            return yield call(batchCreate, payload)
        },
        *update({payload}, {call}) {
            return yield call(update, payload)
        },
        *remove({payload}, {call}) {
            return yield call(remove, payload)
        },
        // 批量删除素材
        *batchRemove({payload}, {call}) {
            return yield call(batchRemove, payload)
        },
        // 分组列表
        *groups({payload}, {select, call, put}) {
            const res = yield call(groups, payload)
            if (res && res.data) {
                const {data} = res
                treeForEach(data, (item, parent) => {
                    // eslint-disable-next-line no-param-reassign
                    item.parent = parent
                })

                const extraGroup = [
                    {
                        children: [],
                        id: 0,
                        name: '未分组',
                        parent_id: 0,
                        priority: 0,
                    },
                ]
                const splicedGroups = extraGroup.concat(data)
                yield put({
                    type: 'setProperty',
                    payload: {
                        originGroups: data,
                        groups: splicedGroups,
                    },
                })

                const expandedKeys = yield select(
                    ({crm_material}) => crm_material.groupExpandedKeys,
                )
                const groupExpandedKeys = splicedGroups.map((item) => String(item.id))
                if (!expandedKeys.length) {
                    yield put({
                        type: 'setProperty',
                        payload: {
                            groupExpandedKeys,
                        },
                    })
                }

                const groupSelectedKey = yield select(
                    ({crm_material}) => crm_material.groupSelectedKey,
                )
                if (groupSelectedKey == null && splicedGroups[0]) {
                    yield put({
                        type: 'setProperty',
                        payload: {
                            groupSelectedKey: _.get(splicedGroups[0], 'id', ''),
                        },
                    })
                }
                return data
            }
        },
        // 创建分组
        *createGroup({payload}, {call}) {
            return yield call(createGroup, payload)
        },
        // 更新分组
        *updateGroup({payload}, {call}) {
            return yield call(updateGroup, payload)
        },
        // 删除分组
        *removeGroup({payload}, {call}) {
            return yield call(removeGroup, payload)
        },
        // 批量分组
        *batchGroup({payload}, {call}) {
            return yield call(batchGroup, payload)
        },
        // 批量设置可见范围
        *batchShare({payload}, {call}) {
            return yield call(batchShare, payload)
        },
        // 获取网页信息
        *webPageInfo({payload}, {call}) {
            return yield call(webPageInfo, payload)
        },
        // 获取小程序
        *mpa({payload}, {call}) {
            return yield call(mpa, payload)
        },
    },

    reducers: {
        setProperty(state, action) {
            return {...state, ...action.payload}
        },
        updateGroupTree(state) {
            return {...state, ...state.groups}
        },
        resetParams(state, action) {
            return {...state, params: {...getInitParams(), ...action.payload}}
        },
        resetState() {
            return getInitState()
        },
    },
}
